import { useHookstate } from '@hookstate/core'
import React, { useEffect } from 'react'
import CrudIndex from '~/components/CrudIndex'
import Layout from '~/components/Layout'
import { useLang } from '~/hooks/useLang'

export default function Index() {
  const { translate } = useLang()

  const forceRefresh = useHookstate(false)
  const name = useHookstate<string | null>(null)
  const weaponTypeId = useHookstate<number | null>(null)

  useEffect(() => {
    document.title = translate('Administration - Dispatch System')
  }, [])

  const weaponKindFilter = [
    {
      name: 'name',
      type: 'name',
      placeholder: 'Name',
      variable: name,
    },
    {
      name: 'weapon_type_id',
      type: 'weapon_type_id',
      placeholder: 'Tipo de Armamento',
      variable: weaponTypeId,
    },
  ]

  return (
    <Layout marginLayout={true}>
      <CrudIndex
        model="weapon-kind"
        title="Weapon Kind"
        disableColumnsFilters
        searchButton={() => forceRefresh.set(!forceRefresh.get())}
        forceRefresh={forceRefresh.get()}
        filters={weaponKindFilter}
        clearFilters={() => {
          name.set(null)
          weaponTypeId.set(null)

          forceRefresh.set(!forceRefresh.get())
        }}
        aliasLabel={[
          { column: 'weapon_type_id', label: 'ID do Tipo de Armamento' },
          { column: 'weapon_type:name', label: 'Tipo de Armamento' },
        ]}
        notSortable={['weapon_type_id', 'weapon_type:name']}
        forceOrderColumns={['name', 'weapon_type:name']}
        canView={true}
        viewTitle="Weapon Kind"
        showInViewMore={['name', 'weapon_type:name', 'created_at']}
      />
    </Layout>
  )
}
